export default "__VITE_ASSET__m30RZ7Ze__"